/**
 * Gestione prodotti visti di recente.
 *
 * - salva localmente nel browser
 * - sincronizza con Shopify tramite App Proxy
 */
export class RecentlyViewed {
  static #STORAGE_KEY = 'viewedProducts';
  static #MAX_PRODUCTS = 4;

  static #SYNC_ENDPOINT = '/apps/marstela-recent';

  /**
   * Aggiunge un prodotto alla cronologia.
   * @param {string} productId
   */
  static addProduct(productId) {
    if (!productId) return;

    const normalizedProductId = String(productId);

    let viewedProducts = this.getProducts();

    viewedProducts = viewedProducts.filter(
      (id) => String(id) !== normalizedProductId
    );

    viewedProducts.unshift(normalizedProductId);

    viewedProducts = viewedProducts.slice(
      0,
      this.#MAX_PRODUCTS
    );

    localStorage.setItem(
      this.#STORAGE_KEY,
      JSON.stringify(viewedProducts)
    );

    this.#syncProduct(normalizedProductId);
  }

  static clearProducts() {
    localStorage.removeItem(this.#STORAGE_KEY);
  }

  /**
   * @returns {string[]}
   */
  static getProducts() {
    try {
      const stored = localStorage.getItem(
        this.#STORAGE_KEY
      );

      const parsed = JSON.parse(
        stored || '[]'
      );

      return Array.isArray(parsed)
        ? parsed
        : [];
    } catch (error) {
      console.error(
        '[MARSTELA RecentlyViewed] localStorage error:',
        error
      );

      return [];
    }
  }

  /**
   * Sincronizza il prodotto col Worker tramite App Proxy.
   * @param {string} productId
   */
  static async #syncProduct(productId) {
    try {
      const response = await fetch(
        this.#SYNC_ENDPOINT,
        {
          method: 'POST',

          headers: {
            'Content-Type': 'application/json',
          },

          body: JSON.stringify({
            productId,
          }),

          credentials: 'same-origin',
        }
      );

      const text = await response.text();

      let result = null;

      try {
        result = JSON.parse(text);
      } catch {
        console.error(
          '[MARSTELA RecentlyViewed] Invalid JSON response:',
          text
        );
        return;
      }

      if (!response.ok) {
        console.error(
          '[MARSTELA RecentlyViewed] HTTP error:',
          response.status,
          result
        );
        return;
      }

      if (!result?.ok) {
        console.error(
          '[MARSTELA RecentlyViewed] Sync error:',
          result
        );
        return;
      }

      if (
        result.saved === false &&
        result.reason ===
          'customer_not_logged_in'
      ) {
        return;
      }

      console.log(
        '[MARSTELA RecentlyViewed] Synced:',
        result
      );
    } catch (error) {
      console.error(
        '[MARSTELA RecentlyViewed] Sync failed:',
        error
      );
    }
  }
}